/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderSearchDto } from './OrderSearchDto';
import {
    OrderSearchDtoFromJSON,
    OrderSearchDtoFromJSONTyped,
    OrderSearchDtoToJSON,
    OrderSearchDtoToJSONTyped,
} from './OrderSearchDto';

/**
 * 
 * @export
 * @interface StringOrderSearchDtoListKeyValuePair
 */
export interface StringOrderSearchDtoListKeyValuePair {
    /**
     * 
     * @type {string}
     * @memberof StringOrderSearchDtoListKeyValuePair
     */
    key?: string | null;
    /**
     * 
     * @type {Array<OrderSearchDto>}
     * @memberof StringOrderSearchDtoListKeyValuePair
     */
    value?: Array<OrderSearchDto> | null;
}

/**
 * Check if a given object implements the StringOrderSearchDtoListKeyValuePair interface.
 */
export function instanceOfStringOrderSearchDtoListKeyValuePair(value: object): value is StringOrderSearchDtoListKeyValuePair {
    return true;
}

export function StringOrderSearchDtoListKeyValuePairFromJSON(json: any): StringOrderSearchDtoListKeyValuePair {
    return StringOrderSearchDtoListKeyValuePairFromJSONTyped(json, false);
}

export function StringOrderSearchDtoListKeyValuePairFromJSONTyped(json: any, ignoreDiscriminator: boolean): StringOrderSearchDtoListKeyValuePair {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'] == null ? undefined : json['key'],
        'value': json['value'] == null ? undefined : ((json['value'] as Array<any>).map(OrderSearchDtoFromJSON)),
    };
}

export function StringOrderSearchDtoListKeyValuePairToJSON(json: any): StringOrderSearchDtoListKeyValuePair {
    return StringOrderSearchDtoListKeyValuePairToJSONTyped(json, false);
}

export function StringOrderSearchDtoListKeyValuePairToJSONTyped(value?: StringOrderSearchDtoListKeyValuePair | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'value': value['value'] == null ? undefined : ((value['value'] as Array<any>).map(OrderSearchDtoToJSON)),
    };
}

